import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';

import { showToast } from '~/components/Shared/EcToast/showToast';
import * as Filters from '~/components/Shared/Filters_DEPRECATED/types';
import { useDebouncedCallback } from '~/hooks/useDebouncedCallback';
import { api } from '~/redux/api/createApi';
import { coerceRtkqError } from '~/redux/api/utils';
import { SearchFilter } from '~/types/DashboardV2';
import { ERROR } from '~/types/toast.types';

import { APISearchSuggestion } from '../advanced-search/types';

const getAsyncOptionsContainer = (searchFilter: SearchFilter) => {
  const AsyncOptionsContainer: Filters.FieldRendererProps = ({
    Component,
    innerProps,
  }) => {
    const intl = useIntl();
    const [getFilterSuggestions, result] =
      api.endpoints.getFilterSuggestions.useLazyQuery();

    const debouncedGetFieldValues = useDebouncedCallback(getFilterSuggestions);

    const { data: response, error, isFetching } = result;
    const selectAllCount = response?.meta?.select_all_count;
    const data = response?.data.map((entity) => entity.attributes);
    const asyncOptions = {
      data: formatData(data || [], searchFilter),
      error,
      isFetching,
      selectAllCount,
    };
    const fetchOptions = (substringQuery = '') => {
      debouncedGetFieldValues({
        filterId: searchFilter.id,
        query: substringQuery,
      });
    };
    const asyncProps = {
      asyncOptions,
      onMount: fetchOptions,
      onQuery: fetchOptions,
    };

    useEffect(() => {
      if (error) {
        showToast(
          ERROR,
          coerceRtkqError(error)?.response?.data?.detail ||
            intl.formatMessage({
              id: 'filters.AsyncOptionsContainer.errorLoadingSuggestions',
              defaultMessage:
                'An error occurred while loading field suggestions.',
              description:
                'Error message shown when field suggestions fail to load',
            }),
        );
      }
    }, [error]);

    return <Component asyncProps={asyncProps} innerProps={innerProps} />;
  };
  return AsyncOptionsContainer;
};

const toFolderItem = (suggestion: APISearchSuggestion) => {
  return {
    label: suggestion.label,
    leftIcon: 'folder',
    leftIconTooltip: suggestion.sub_label,
    description: suggestion.sub_label,
    value: String(suggestion.value),
  };
};

const formatData = (
  data: APISearchSuggestion[],
  searchFilter: SearchFilter,
) => {
  switch (searchFilter.type) {
    case 'folder':
      return data.map(toFolderItem);

    default:
      return data;
  }
};

export default getAsyncOptionsContainer;
